import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  Row,
  Col,
  Button,
  Badge,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import ModalAlterarSenha from "../../../modules/login/components/ModalAlterarSenha";
import ModalPalavraChave from "../../login/components/ModalPalavraChave.js";
import { inject, observer } from "mobx-react";
import lscache from "lscache";

@inject("store")
@observer
class TopBarHeader extends Component {
  constructor(props) {
    super(props);
    this.mensagemOcupacao = "Teste"
    this.loginStore = this.props.store.loginStore;
  }
  
 

    componentDidMount() {
       this.loginStore.RecuperaOcupacaoPatio();
    }




  modalAlterarSenha = () => {
    this.atualizado = true;
    return this.loginStore.showModalAlterarSenha && <ModalAlterarSenha />;
  };

  modalPalavraChave = () => { 
        this.mfaAtualizado = true;
        return this.loginStore.showModalPalavraChave && <ModalPalavraChave />;
    }

    state = {
        showConfig: false
    };

    toggleConfig = () => {
        this.setState({ showConfig: !this.state.showConfig });
    };

  renderStatusIndicator(status, mensagem = '') {
    let color;

    switch (status) {
      case "OK":
        color = "#28a745"; // Verde
        break;
      case "MEDIO":
        color = "#ffc107"; // Amarelo
        break;
      case "ALTO":
        color = "#dc3545"; // Vermelho
        break;
      default:
        color = "#6c757d"; // Cinza (status desconhecido)
    }

    const style = {
      width: "16px",
      height: "16px",
      borderRadius: "50%",
      backgroundColor: color,
      display: "inline-block",
      border: "1px solid #000",
      marginLeft: "10px",
      marginRight: "10px",
      marginBottom: "-2px",

    };
    return <span title={mensagem || status} style={style}></span>;
  }

  render() {
    return lscache.get("access_token") ? (
      this.loginStore.showModalAlterarSenha ? (
        <ModalAlterarSenha />
      ) : 
      this.loginStore.showModalPalavraChave ?(
        <ModalPalavraChave/>
      ): (
        <React.Fragment>
          <Row className="align-items-center ">
            <Col className="px-2 mb-1" xs={{ size: "auto", order: 3 }}>
              <b>
                {lscache.get("Nome")
                  ? lscache.get("Nome").toLowerCase() != "undefined"
                    ? lscache.get("Nome")
                    : "-"
                  : "-"}
              </b>
            </Col>
            <Col
              className="px-2 mb-1 ml-lg-auto order-xs-1 justify-content-end"
              sm={{ order: 4 }}
              xs={{ size: "auto", order: 4 }}
            >
              <Nav className="ml-auto" navbar>
                <UncontrolledDropdown nav direction="down">
                  <DropdownToggle nav>
                    <Button
                      title="Gerenciar Perfil"
                      className="btn-icon-secondary btn-rounded"
                    >
                      <FontAwesomeIcon icon={["fas", "user"]} size={"lg"} />
                    </Button>
                  </DropdownToggle>
                  <DropdownMenu right className="m-0 p-0">
                    <DropdownItem
                      tag="div"
                      header
                      className="toolbar-title h4 text-center"
                    >
                      Minha Conta
                    </DropdownItem>
                    <DropdownItem divider className="m-0 p-0" />
                    <DropdownItem tag="div" className="toolbar-text">
                      <b>E-mail:</b>{" "}
                      {lscache.get("Email")
                        ? lscache.get("Email").toLowerCase()
                        : "-"}
                    </DropdownItem>
                    <DropdownItem divider className="m-0 p-0" />
                    <DropdownItem
                      tag="div"
                      header
                      className="toolbar-title h4 text-center"
                    >
                      PERFIL
                    </DropdownItem>
                    <DropdownItem divider className="m-0 p-0" />
                    <DropdownItem
                      tag="div"
                      header
                      className="toolbar-text text-center"
                    >
                      {" "}
                      {lscache.get("Perfil")
                        ? lscache.get("Perfil").map((element, index) => (
                            <span key={index}>
                              {" "}
                              {element} <br />
                            </span>
                          ))
                        : "-"}
                    </DropdownItem>
                    <DropdownItem divider className="m-0 p-0" />
                    <Link to="meu-tecon">
                      <DropdownItem className="toolbar-option mt-2 mb-2">
                        <FontAwesomeIcon
                          className="mr-3"
                          icon={"chalkboard-teacher"}
                          size={"sm"}
                        />
                        Meu Tecon
                      </DropdownItem>
                    </Link>
                    <DropdownItem divider />
                    <DropdownItem 
                        toggle={false}
                        className="toolbar-option d-flex justify-content-between align-items-center"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.toggleConfig();
                        }}
                        >
                        <div><FontAwesomeIcon className="mr-3" icon={"cog"} size={"sm"} />Configurações de acesso</div>
                        <FontAwesomeIcon icon={this.state.showConfig ? "chevron-up" : "chevron-down"} size={"sm"} />
                    </DropdownItem>

                    {this.state.showConfig && (
                        <div className="pl-4">
                            <DropdownItem className="toolbar-option" onClick={() => this.loginStore.abrirModalAlterarSenha()}>
                                <FontAwesomeIcon className="mr-3" icon={"key"} size={"sm"} />Alterar Senha
                            </DropdownItem>
                            <DropdownItem className="toolbar-option" onClick={() => this.loginStore.abrirModalPalavraAtualizarCelular()}>
                                <FontAwesomeIcon className="mr-3" icon={"phone"} size={"sm"} />Atualizar Celular
                            </DropdownItem>
                        </div>
                    )}
                    <DropdownItem divider />
                    <DropdownItem
                      className="toolbar-option mt-2 mb-2"
                      onClick={() => this.props.logout()}
                    >
                      <FontAwesomeIcon
                        className="mr-3"
                        icon={"sign-out-alt"}
                        size={"sm"}
                      />
                      Sair
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Col>
            <Col
              className="pr-2 pl-0 mb-1 ml-lg-auto order-xs-1 justify-content-end"
              xs={{ size: "auto", order: 5 }}
            >
              <Button
                title="Portal de Atendimento"
                target="blank"
                href={
                  process.env.rig
                    ? "http://atendimento.teconline.com.br/"
                    : "http://atendimento.teconsvonline.com.br/"
                }
                className="btn-icon-secondary btn-rounded"
              >
                <FontAwesomeIcon icon={["fas", "headset"]} size={"lg"} />
              </Button>
            </Col>
            {
              <Col
                className="px-0 mb-1 ml-lg-auto order-xs-1 justify-content-end"
                xs={{ size: "auto", order: 5 }}
              >
                <Button
                  title="Contato via Whatsapp"
                  target="blank"
                  href={
                    process.env.rig
                      ? "https://api.whatsapp.com/send?phone=555332343030"
                      : "https://api.whatsapp.com/send?phone=557121061500"
                  }
                  className="btn-icon-destaque btn-rounded"
                >
                  <FontAwesomeIcon icon={faWhatsapp} size={"lg"} />
                </Button>
              </Col>
            }
          </Row>
        </React.Fragment>
      )
    ) : (
      <React.Fragment>
        <Row className="align-items-center ">
          <Col
            className="px-2 mb-1 ml-lg-auto order-xs-1 justify-content-end"
            sm={{ order: 4 }}
            xs={{ size: "auto", order: 4 }}
          >
            <Nav className="ml-auto" navbar>
              <UncontrolledDropdown nav direction="down">
                <DropdownToggle nav>
                  <Button
                    title="Gerenciar Perfil"
                    className="btn-icon-secondary btn-rounded"
                  >
                    <FontAwesomeIcon icon={["fas", "user"]} size={"lg"} />
                  </Button>
                </DropdownToggle>
                <DropdownMenu right className="m-0 p-0">
                  <DropdownItem
                    className="toolbar-option mt-2 mb-2"
                    onClick={() => this.props.logout()}
                  >
                    <FontAwesomeIcon
                      className="mr-3"
                      icon={"sign-in-alt"}
                      size={"sm"}
                    />
                    Login
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Col>
          <Col
            className="pr-2 pl-0 mb-1 ml-lg-auto order-xs-1 justify-content-end"
            xs={{ size: "auto", order: 5 }}
          >
            <Button
              title="Portal de Atendimento"
              target="blank"
              href={
                process.env.rig
                  ? "http://atendimento.teconline.com.br/"
                  : "http://atendimento.teconsvonline.com.br/"
              }
              className="btn-icon-secondary btn-rounded"
            >
              <FontAwesomeIcon icon={["fas", "headset"]} size={"lg"} />
            </Button>
          </Col>
          {
            <Col
              className="px-0 mb-1 ml-lg-auto order-xs-1 justify-content-end"
              xs={{ size: "auto", order: 5 }}
            >
              <Button
                title="Contato via Whatsapp"
                target="blank"
                href={
                  process.env.rig
                    ? "https://api.whatsapp.com/send?phone=555332343030"
                    : "https://api.whatsapp.com/send?phone=557121061500"
                }
                className="btn-icon-secondary btn-rounded"
              >
                <FontAwesomeIcon icon={faWhatsapp} size={"lg"} />
              </Button>
            </Col>
          }
        </Row>
      </React.Fragment>
    );
  }
}

export default TopBarHeader;



// WEBPACK FOOTER //
// ./src/modules/comum/components/TopBarHeader.js